import React from 'react';
import MenuProfitability from './MenuProfitability';
import MenuCoach from './MenuCoach';
import RecipeHealth from './RecipeHealth';

// Menu hub. Hosts product/strategy surfaces:
//   - Menu          (Menu Profitability — default)
//   - Recipe Health (linkage management queue — see DESIGN_SYSTEM.md
//                    §Recipe Health surface)
//   - Menu Coach
//
// Sidebar's MENU group renders all three as direct nav links — no in-page
// tab strip (would duplicate the sidebar control).

export default function Menu({ companyId, initialTab = 'profitability', navConfig, onConsumeNavConfig }) {
  const tab = initialTab;

  switch (tab) {
    case 'profitability':
      return (
        <MenuProfitability
          companyId={companyId}
          navConfig={navConfig}
          onConsumeNavConfig={onConsumeNavConfig}
        />
      );
    case 'health':
      return <RecipeHealth companyId={companyId} />;
    case 'coach':
      return <MenuCoach companyId={companyId} />;
    default:
      return null;
  }
}
